import React from 'react';
import PropTypes from 'prop-types';

const UiNavigationForwardPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M20.63 15.964l-8.543-8.506a.298.298 0 0 1 0-.422l.95-.949a.298.298 0 0 1 .421 0l9.702 9.702a.298.298 0 0 1 0 .422l-9.702 9.702a.298.298 0 0 1-.422 0l-.949-.986a.298.298 0 0 1 0-.421l8.542-8.542z"
    />
  );
};

UiNavigationForwardPath.propTypes = {
  fill: PropTypes.string,
};

export default UiNavigationForwardPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-navigation-forward.jsx